import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import LayoutRoutes from './MMPClient/LayoutRoutes';
import { PublicRoutes } from './PublicRoutes';
import { MMPClientAuthRoutes } from './MMPClient/MMPClientRoutes';
import { CRMAuthRoutes, CRMRoutes } from './CRMAdmin/CRMRoutes';
import PrivateRoutes from './MMPClient/PrivateRoutes';
import CRMLayout from '../CRMLayout/CRMLayout';

export default function Routers() {
    return (
        <BrowserRouter basename="/">
            <Routes>
                {PublicRoutes.map((route, index) => (
                    <Route key={index} path={route.path} element={route.element} />
                ))}

                {MMPClientAuthRoutes.map((route, index) => (
                    <Route key={index} path={route.path} element={route.element} />
                ))}

                {CRMAuthRoutes.map((route, index) => (
                    <Route key={index} path={route.path} element={route.element} />
                ))}
                <Route path="/" element={<Navigate to="/crmlogin" replace />} />
                <Route path="/" element={<PrivateRoutes />}>
                    <Route path="/*" element={<LayoutRoutes />} />
                </Route>

                {CRMRoutes.map(({ path, element }, i) => (
                    <Route element={<CRMLayout />} key={i}>
                        <Route path={path} element={element} />
                    </Route>
                ))}
            </Routes>
        </BrowserRouter>
    );
}
